import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import GoogleAnalytics from "./GoogleAnalytics";
import { ThemeProvider } from "./theme/context";


function App() {
  return (
    <ThemeProvider>
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <GoogleAnalytics />
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
    </ThemeProvider>
  );
}

export default App;
